import React from 'react';

const Button = ({ children, onClick, className }) => {
  return (
    <button
      className={`flex items-center justify-center min-h-8 px-2 py-1 bg-white text-black rounded-md shadow-sm z-50 pointer-events-auto cursor-pointer ${className || ''}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
